import { Link, useNavigate } from "react-router-dom";
import { User, Building, ArrowLeft } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";

const ProfileChoice = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const handleChoice = (type) => {
    // Store choice in sessionStorage for registration flow
    sessionStorage.setItem("selectedUserType", type);
    
    if (user) {
      // If already logged in, go to checkout
      navigate("/checkout");
    } else {
      // If not logged in, go to registration
      navigate("/inscription");
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 font-['DM_Sans']">
      {/* Header */}
      <header className="bg-white border-b border-slate-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <Link to="/" className="flex items-center gap-2">
              <img src="/logo-hostprotect.png" alt="HostProtect" className="h-9 w-auto" />
            </Link>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="py-16 sm:py-24">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-slate-600 hover:text-[#19294C] mb-8 transition-colors"
            data-testid="back-link"
          >
            <ArrowLeft className="w-4 h-4" />
            Retour à l'accueil
          </Link>

          <div className="text-center mb-12">
            <h1 className="text-3xl sm:text-4xl font-bold text-[#19294C] font-['Outfit']">
              Choisissez votre profil
            </h1>
            <p className="mt-4 text-slate-600">
              Sélectionnez le type de compte qui correspond à votre situation.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            {/* Particulier Card */}
            <button
              onClick={() => handleChoice("particulier")}
              className="group bg-white border-2 border-slate-200 rounded-2xl p-8 text-left hover:border-[#00B8E4] hover:shadow-lg transition-all duration-200 hover:-translate-y-1 focus:outline-none focus:ring-2 focus:ring-[#00B8E4] focus:ring-offset-2"
              data-testid="profile-particulier-btn"
            >
              <div className="w-16 h-16 bg-blue-50 rounded-xl flex items-center justify-center mb-6 group-hover:bg-[#00B8E4]/5 transition-colors">
                <User className="w-8 h-8 text-[#19294C] group-hover:text-[#00B8E4] transition-colors" />
              </div>
              <h2 className="text-xl font-semibold text-[#19294C] font-['Outfit'] mb-2">
                Je suis un Particulier
              </h2>
              <p className="text-slate-600">
                Propriétaire d'un ou plusieurs logements que vous mettez en location saisonnière.
              </p>
              <div className="mt-6 flex items-center text-[#00B8E4] font-medium opacity-0 group-hover:opacity-100 transition-opacity">
                Continuer
                <ArrowLeft className="w-4 h-4 ml-2 rotate-180" />
              </div>
            </button>

            {/* Professionnel Card */}
            <button
              onClick={() => handleChoice("professionnel")}
              className="group bg-white border-2 border-slate-200 rounded-2xl p-8 text-left hover:border-[#00B8E4] hover:shadow-lg transition-all duration-200 hover:-translate-y-1 focus:outline-none focus:ring-2 focus:ring-[#00B8E4] focus:ring-offset-2"
              data-testid="profile-professionnel-btn"
            >
              <div className="w-16 h-16 bg-blue-50 rounded-xl flex items-center justify-center mb-6 group-hover:bg-[#00B8E4]/5 transition-colors">
                <Building className="w-8 h-8 text-[#19294C] group-hover:text-[#00B8E4] transition-colors" />
              </div>
              <h2 className="text-xl font-semibold text-[#19294C] font-['Outfit'] mb-2">
                Je suis un Professionnel
              </h2>
              <p className="text-slate-600">
                Conciergerie, gestionnaire immobilier ou société gérant plusieurs biens en location courte durée.
              </p>
              <div className="mt-6 flex items-center text-[#00B8E4] font-medium opacity-0 group-hover:opacity-100 transition-opacity">
                Continuer
                <ArrowLeft className="w-4 h-4 ml-2 rotate-180" />
              </div>
            </button>
          </div>

          <p className="text-center text-sm text-slate-500 mt-8">
            Vous avez déjà un compte ?{" "}
            <Link to="/connexion" className="text-[#00B8E4] hover:underline font-medium">
              Connectez-vous
            </Link>
          </p>
        </div>
      </main>
    </div>
  );
};

export default ProfileChoice;
